import "./footer.css";
import { Link } from "react-router-dom";
import packageInfo from "../../../package.json";

const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";

const footer_bg = `${digitalOceanURL}/FooterAssets/footerBg.svg`;

export default function Footer() {
  // console.log(`App Version: ${packageInfo.version}`);
  return (
    <div>
      <footer className="relative bottom-0 border-t border-opacity-0  border-white footer  ">
        <div
          className="absolute -z-10 inset-0 w-full h-full bg-no-repeat bg-cover bg_center"
          style={{ backgroundImage: `url(${footer_bg})` }}
        />
        {/* z-index-10 */}
        <div className="relative  footer-content-wrapper mx-auto   space-y-8 lg:space-y-8 ">
          {/* center this div */}
          <div className="mx-auto md:mb-[4rem] mb-[2rem] lg:mb-[2rem]  max-w-5xl 2xl:max-w-7xl px-4   ">
            <div className="grid  sm:grid-cols-1 md:grid-col-2 gap-8 lg:grid-cols-3 ">
              <div className="hire-star-left">
                {/* --------logo-------------- */}
                <div className=" text-teal-600 sm:justify-start">
                  <svg
                    width="220"
                    height="49"
                    viewBox="0 0 274 49"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.4832 1.89722C14.8987 3.19873 14.5993 3.86741 14.5993 6.10712C14.5993 9.82821 16.5487 11.704 20.4158 11.704C24.2829 11.704 26.2324 9.82821 26.2324 6.10712C26.2324 3.86741 25.933 3.19873 24.3484 1.89722C23.1435 0.907036 21.7267 0.350098 20.4158 0.350098C19.105 0.350098 17.6882 0.907036 16.4832 1.89722ZM149.299 6.25173C143.741 7.43971 140.666 10.6074 140.243 15.5787C140.044 17.9164 140.296 19.2705 141.28 21.1528C142.823 24.1036 145.217 25.4279 151.748 26.9421C159.848 28.8203 162.781 30.9381 161.573 34.0377C160.758 36.131 159.138 36.8021 154.896 36.8021C151.862 36.8021 150.91 36.5403 149.378 35.2818C148.36 34.4458 147.357 33.2358 147.147 32.5928C146.826 31.6032 146.202 31.4239 143.086 31.4239H139.405L139.834 33.366C140.784 37.6751 143.566 40.6451 148.012 42.0978C150.617 42.9487 158.035 42.9756 161.101 42.1444C164.158 41.3161 167.418 38.4514 168.311 35.8089C168.708 34.6383 168.908 32.2253 168.757 30.4475C168.3 25.0675 166.017 23.4379 155.023 20.6425C152.279 19.9445 149.455 18.8474 148.748 18.2044C146.959 16.5778 147.118 14.4463 149.146 12.8836C150.538 11.811 151.407 11.6329 154.166 11.854C157.114 12.09 157.737 12.3858 159.512 14.3895C161.226 16.325 161.972 16.7003 164.594 16.9459C167.482 17.2166 167.667 17.1509 167.667 15.8529C167.667 13.1919 165.216 9.3633 162.53 7.82694C159.704 6.2105 153.146 5.42947 149.299 6.25173ZM49.6352 8.4514C48.2833 9.37525 48.2741 9.49715 48.2729 26.2292L48.2717 43.0766L51.9465 42.874L55.6214 42.6714V34.9376V27.2038L63.1076 27.3718L70.5938 27.5397L70.3997 34.8307C70.2932 38.8404 70.3415 42.3362 70.5075 42.5991C70.6728 42.8615 72.4888 42.9858 74.5417 42.874L78.2753 42.6714V25.0675V7.46421L74.4487 7.64169L70.622 7.81976L70.4481 14.2437L70.2742 20.6676H62.9478H55.6214V14.0943V7.52098H53.3088C52.0365 7.52098 50.3834 7.93988 49.6352 8.4514ZM82.5612 10.5088V13.4967H86.2348H89.9085V11.704C89.9085 9.14877 88.0019 7.52098 85.0103 7.52098H82.5612V10.5088ZM173.789 23.9542C173.789 43.5505 173.513 42.7778 180.524 42.7778H184.81V40.0887C184.81 37.5215 184.73 37.3996 183.039 37.3996C181.988 37.3996 181.116 37.0148 180.896 36.4543C180.692 35.9344 180.524 32.1912 180.524 28.1361V20.7626L182.356 20.37C183.754 20.0706 184.308 19.528 184.696 18.0813C185.19 16.2438 185.138 16.1768 183.018 15.887C180.875 15.5942 180.827 15.5273 180.638 12.6045C180.395 8.84998 179.22 7.52098 176.144 7.52098H173.789V23.9542ZM238.69 10.5088V13.4967H242.364H246.037V11.4978C246.037 8.83504 244.453 7.52098 241.244 7.52098H238.69V10.5088ZM8.67128 11.6353C2.46347 16.0238 -0.356032 21.8155 0.0358206 29.3742C0.250115 33.5041 0.594822 34.7476 2.43959 38.039C10.3758 52.1985 31.8953 51.6619 39.0827 37.1254C41.2134 32.8157 41.5055 25.7422 39.7415 21.1773C38.3137 17.4843 34.6915 13.0694 31.5175 11.1548L29.4903 9.93219L26.6194 12.6171C25.0397 14.0943 23.487 15.9719 23.1686 16.7899C22.7014 17.9893 22.1682 18.2773 20.4158 18.2773C18.6635 18.2773 18.1302 17.9893 17.6631 16.7899C17.2253 15.6659 11.83 9.91127 11.214 9.91127C11.1565 9.91127 10.0121 10.6869 8.67128 11.6353ZM116.694 15.9282C111.942 18.3765 109.506 24.9181 110.685 32.0639C111.883 39.3262 115.942 42.7778 123.283 42.7778C128.785 42.7778 132.849 40.6582 134.968 36.6826C136.321 34.1453 136.06 33.8142 132.702 33.8142C130.261 33.8142 129.178 34.1417 127.758 35.3081C124.77 37.7618 120.526 37.3082 118.969 34.3688C117.109 30.8586 117.183 30.8263 127.257 30.8263H136.441V28.5448C136.441 25.4864 134.903 20.6025 133.323 18.6418C130.158 14.7152 121.721 13.3384 116.694 15.9282ZM192.792 16.0364C191.121 16.8724 189.68 18.1715 188.98 19.4724L187.855 21.5639L191.237 21.7432C193.549 21.8663 195.046 21.6297 195.973 20.9963C198.586 19.2101 203.791 20.1501 203.791 22.4083C203.791 24.1108 202.544 24.7604 197.45 25.7117C194.862 26.1951 191.928 27.061 190.93 27.6365C185.859 30.5604 186.22 38.9497 191.535 41.6813C194.239 43.0712 201.053 43.1608 204.269 41.8498C209.855 39.5724 211.41 35.8543 211.047 25.6352C210.842 19.8435 210.744 19.4593 209.03 17.7138C205.77 14.3949 197.731 13.5642 192.792 16.0364ZM254.321 16.0555C252.984 16.7947 251.278 18.2857 250.53 19.3691C248.733 21.9715 247.644 27.306 248.15 31.0283C249.255 39.1595 253.224 42.7778 261.038 42.7778C268.15 42.7778 272.247 39.4607 273.604 32.6053C275.118 24.9534 272.186 17.8488 266.569 15.5577C263.251 14.2048 257.226 14.4498 254.321 16.0555ZM82.5612 29.2768V42.6673L85.9808 42.8716C87.8623 42.9846 89.5154 42.9642 89.6544 42.8274C89.794 42.6906 89.9085 37.0178 89.9085 30.2216C89.9085 16.1416 89.8234 15.887 85.115 15.887H82.5612V29.2768ZM100.623 16.6172C97.3659 17.7443 95.3099 19.583 93.8233 22.6999C92.5051 25.4631 92.3686 26.5537 92.3624 34.4118L92.3551 43.0766L96.0299 42.874L99.7048 42.6714V35.344C99.7048 31.314 99.9938 27.2068 100.348 26.2173C101.083 24.1586 103.108 23.0579 106.162 23.0579H108.277V19.4724V15.887L105.368 15.9342C103.768 15.9599 101.633 16.2677 100.623 16.6172ZM222.483 16.8395C221.146 17.3176 219.252 18.4416 218.275 19.3374C215.23 22.1281 214.636 24.3295 214.328 33.9636L214.047 42.7778H217.752H221.456L221.654 34.0586C221.844 25.7302 221.918 25.2886 223.298 24.1986C224.229 23.4636 225.699 23.0579 227.431 23.0579H230.118V19.4724V15.887L227.516 15.9288C226.085 15.9521 223.82 16.3621 222.483 16.8395ZM238.831 29.4005L238.996 42.914L242.517 42.9953L246.038 43.0766V30.1989C246.037 20.9801 245.829 17.1174 245.303 16.6041C244.898 16.2097 243.24 15.887 241.617 15.887H238.667L238.831 29.4005ZM23.9952 26.4939C24.8983 30.356 25.633 33.9074 25.6287 34.3867C25.6189 35.4097 21.393 39.7899 20.4158 39.7899C20.0472 39.7899 18.6868 38.731 17.3918 37.4367L15.037 35.0834L15.781 31.3116C16.1899 29.2368 16.94 25.7249 17.4482 23.5061C18.3562 19.5376 18.4033 19.4724 20.3626 19.4724H22.3537L23.9952 26.4939ZM126.978 22.1346C127.805 22.9414 128.481 24.1514 128.481 24.8237C128.481 25.9591 128.112 26.0457 123.277 26.0457C118.443 26.0457 118.073 25.9591 118.073 24.8237C118.073 22.8195 120.768 20.6676 123.277 20.6676C124.795 20.6676 125.941 21.1217 126.978 22.1346ZM264.633 22.3802C267.007 24.7986 267.489 29.5529 265.749 33.3911C264.884 35.301 264.029 36.2738 262.993 36.5278C260.448 37.1511 258.149 36.572 256.969 35.0093C255.64 33.2489 254.904 28.7802 255.464 25.8653C256.418 20.9036 261.345 19.0308 264.633 22.3802ZM204.403 30.4385C204.403 32.7953 203.166 35.4778 201.623 36.4638C199.715 37.6847 196.527 37.6584 195.114 36.4107C192.571 34.1644 194.552 31.2883 199.505 30.0363C204.213 28.8466 204.403 28.8621 204.403 30.4385ZM230.527 37.7982C230.302 38.0169 230.118 39.2001 230.118 40.4269C230.118 42.6457 230.133 42.6589 232.917 42.8746C234.456 42.9941 235.833 42.9762 235.978 42.8352C236.123 42.6941 236.241 41.4135 236.241 39.9889V37.3996H233.588C232.128 37.3996 230.751 37.5789 230.527 37.7982Z"
                      fill="white"
                    />
                  </svg>
                  <p className="mt-5 opacity-90  text-white max-w-md text-pretty leading-relaxed  sm:max-w-xs sm:text-left">
                    Offer Experience and Employee Background Verification
                    powered by blockchain
                  </p>
                </div>

                <div className="text-start follow-us-container     lg:mt-6 ">
                  <h4 className="font-semibold text-base text-white mb-3">
                    Follow Us On
                  </h4>
                  <ul className="mt-2  flex justify-start  sm:justify-start gap-3 md:gap-4">
                    <li>
                      <a
                        aria-label="Visit HireStar.io LinkedIn Page"
                        rel="noreferrer"
                        target="_blank"
                        className="text-teal-700 transition hover:text-teal-700/75"

                        href="https://in.linkedin.com/showcase/hirestar.io/"
                      >
                        {/* linkedInIcon */}
                        <svg
                          width="32"
                          height="33"
                          viewBox="0 0 32 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            fill="#0D6EB5"
                          />
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            stroke="white"
                          />
                          <path
                            d="M12.0244 23.5499H9.0389V13.9358H12.0244V23.5499ZM10.5299 12.6244C9.57532 12.6244 8.80078 11.8334 8.80078 10.8789C8.80078 10.4204 8.98295 9.98058 9.30722 9.65632C9.63149 9.33207 10.0713 9.1499 10.5299 9.1499C10.9885 9.1499 11.4283 9.33207 11.7525 9.65632C12.0768 9.98058 12.259 10.4204 12.259 10.8789C12.259 11.8334 11.4844 12.6244 10.5299 12.6244ZM23.1982 23.5499H20.2194V18.8699C20.2194 17.7544 20.1967 16.3242 18.6672 16.3242C17.115 16.3242 16.8769 17.5358 16.8769 18.7897V23.5499H13.8944V13.9358H16.7576V15.2473H16.7992C17.1978 14.4918 18.1714 13.6946 19.6238 13.6946C22.6453 13.6946 23.2008 15.6844 23.2008 18.2687V23.5499H23.1982Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    </li>

                    <li>
                      <a
                        aria-label="Visit HireStar.io Facebook Page"
                        rel="noreferrer"
                        target="_blank"
                        className="text-teal-700 transition hover:text-teal-700/75"
                        href="https://www.facebook.com/hirestario"
                      >
                        {/* facebook Iocon */}
                        <svg
                          width="32"
                          height="33"
                          viewBox="0 0 32 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            fill="#0D6EB5"
                          />
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            stroke="white"
                          />
                          <path
                            d="M17.0659 17.6703H19.1611L19.9992 14.1503H17.0659V12.3903C17.0659 11.4839 17.0659 10.6303 18.7421 10.6303H19.9992V7.67349C19.726 7.63565 18.6943 7.55029 17.6048 7.55029C15.3294 7.55029 13.7135 9.00845 13.7135 11.6863V14.1503H11.1992V17.6703H13.7135V25.1503H17.0659V17.6703Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    </li>

                    {/* Twitter */}
                    <li>
                      <a
                        aria-label="Visit HireStar.io Twitter Page"
                        rel="noreferrer"
                        target="_blank"
                        className="text-teal-700 transition hover:text-teal-700/75"
                        href="https://twitter.com/Hirestario?t=YOq_b92bZL8gZxDuS21hRQ&s=09"
                      >
                        {/* Twitter Iocon */}
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#0D6EB5" />
                          <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="white" />
                          <path d="M24.7804 11.7498C24.1708 12.0269 23.5138 12.209 22.8329 12.2961C23.5296 11.8765 24.0679 11.2115 24.3213 10.4119C23.6642 10.8078 22.9358 11.0848 22.1679 11.2432C21.5425 10.5623 20.6638 10.1665 19.6663 10.1665C17.8058 10.1665 16.2858 11.6865 16.2858 13.5628C16.2858 13.8319 16.3175 14.0932 16.3729 14.3386C13.5546 14.1961 11.045 12.8423 9.37458 10.7919C9.08167 11.2907 8.91542 11.8765 8.91542 12.494C8.91542 13.6736 9.50917 14.7186 10.4275 15.3123C9.86542 15.3123 9.34292 15.154 8.88375 14.9165V14.9403C8.88375 16.5869 10.0554 17.9644 11.6071 18.2732C11.109 18.4101 10.5859 18.4291 10.0792 18.3286C10.2942 19.0035 10.7153 19.594 11.2833 20.0172C11.8513 20.4403 12.5376 20.6748 13.2458 20.6878C12.0454 21.6382 10.5573 22.1519 9.02625 22.1444C8.75708 22.1444 8.48792 22.1286 8.21875 22.0969C9.72292 23.0628 11.5121 23.6248 13.4279 23.6248C19.6663 23.6248 23.0942 18.4473 23.0942 13.9586C23.0942 13.8082 23.0942 13.6657 23.0863 13.5153C23.7513 13.0403 24.3213 12.4386 24.7804 11.7498Z" fill="white" />
                        </svg>
                      </a>
                    </li>
                    {/* Instagram */}
                    <li>
                      <a
                        aria-label="Visit HireStar.io Instagram Page"
                        href="https://www.instagram.com/hirestar.io/"
                        rel="noreferrer"
                        target="_blank"
                        className="text-teal-700  transition hover:text-teal-700/75"
                      >
                        <svg
                          width="32"
                          height="33"
                          viewBox="0 0 32 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            fill="#0D6EB5"
                          />
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            stroke="white"
                          />
                          <path
                            d="M16.7196 9.3501C17.5071 9.3522 17.9067 9.3564 18.2518 9.3662L18.3876 9.3711C18.5444 9.3767 18.6991 9.3837 18.886 9.3921C19.6308 9.42709 20.1389 9.54469 20.5848 9.71758C21.0468 9.89537 21.436 10.1362 21.8251 10.5246C22.1811 10.8745 22.4565 11.2978 22.6322 11.765C22.8051 12.2109 22.9227 12.719 22.9577 13.4645C22.9661 13.6507 22.9731 13.8054 22.9787 13.9629L22.9829 14.0987C22.9934 14.443 22.9976 14.8427 22.999 15.6302L22.9997 16.1523V17.0693C23.0014 17.5799 22.996 18.0904 22.9836 18.6008L22.9794 18.7366C22.9738 18.8941 22.9668 19.0488 22.9584 19.235C22.9234 19.9805 22.8044 20.4879 22.6322 20.9345C22.457 21.4019 22.1815 21.8253 21.8251 22.1748C21.4751 22.5306 21.0519 22.806 20.5848 22.9819C20.1389 23.1548 19.6308 23.2724 18.886 23.3074C18.7199 23.3152 18.5538 23.3222 18.3876 23.3284L18.2518 23.3326C17.9067 23.3424 17.5071 23.3473 16.7196 23.3487L16.1974 23.3494H15.2812C14.7704 23.3511 14.2596 23.3458 13.749 23.3333L13.6132 23.3291C13.447 23.3228 13.2809 23.3156 13.1148 23.3074C12.37 23.2724 11.8619 23.1548 11.4153 22.9819C10.9482 22.8065 10.5251 22.531 10.1756 22.1748C9.81939 21.8251 9.54373 21.4018 9.36789 20.9345C9.19499 20.4886 9.0774 19.9805 9.0424 19.235C9.0346 19.0689 9.0276 18.9028 9.0214 18.7366L9.0179 18.6008C9.005 18.0904 8.99917 17.5799 9.0004 17.0693V15.6302C8.99845 15.1196 9.00358 14.6091 9.0158 14.0987L9.0207 13.9629C9.0263 13.8054 9.0333 13.6507 9.0417 13.4645C9.0767 12.719 9.19429 12.2116 9.36719 11.765C9.54296 11.2973 9.81917 10.8739 10.1763 10.5246C10.5257 10.1687 10.9485 9.89326 11.4153 9.71758C11.8619 9.54469 12.3693 9.42709 13.1148 9.3921C13.301 9.3837 13.4564 9.3767 13.6132 9.3711L13.749 9.3669C14.2594 9.35446 14.7699 9.34909 15.2805 9.3508L16.7196 9.3501ZM16 12.8499C15.0718 12.8499 14.1816 13.2186 13.5253 13.875C12.869 14.5313 12.5002 15.4215 12.5002 16.3497C12.5002 17.2779 12.869 18.1681 13.5253 18.8245C14.1816 19.4808 15.0718 19.8496 16 19.8496C16.9283 19.8496 17.8184 19.4808 18.4748 18.8245C19.1311 18.1681 19.4999 17.2779 19.4999 16.3497C19.4999 15.4215 19.1311 14.5313 18.4748 13.875C17.8184 13.2186 16.9283 12.8499 16 12.8499ZM16 14.2498C16.2758 14.2498 16.5489 14.3041 16.8037 14.4096C17.0585 14.515 17.29 14.6697 17.485 14.8646C17.68 15.0596 17.8347 15.2911 17.9403 15.5458C18.0459 15.8006 18.1002 16.0736 18.1003 16.3494C18.1003 16.6252 18.0461 16.8982 17.9406 17.153C17.8351 17.4078 17.6805 17.6393 17.4855 17.8343C17.2905 18.0294 17.0591 18.1841 16.8043 18.2897C16.5496 18.3952 16.2765 18.4496 16.0007 18.4496C15.4438 18.4496 14.9097 18.2284 14.5159 17.8346C14.1221 17.4408 13.9009 16.9067 13.9009 16.3497C13.9009 15.7928 14.1221 15.2587 14.5159 14.8649C14.9097 14.4711 15.4438 14.2498 16.0007 14.2498M19.6756 11.8C19.4435 11.8 19.221 11.8922 19.0569 12.0562C18.8928 12.2203 18.8006 12.4429 18.8006 12.6749C18.8006 12.907 18.8928 13.1295 19.0569 13.2936C19.221 13.4577 19.4435 13.5499 19.6756 13.5499C19.9076 13.5499 20.1302 13.4577 20.2942 13.2936C20.4583 13.1295 20.5505 12.907 20.5505 12.6749C20.5505 12.4429 20.4583 12.2203 20.2942 12.0562C20.1302 11.8922 19.9076 11.8 19.6756 11.8Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* links container */}
              <div className="grid  grid-cols-2 md:grid-cols-3  lg:col-span-2">
                <div className="  sm:text-left">
                  <p className="font-semibold text-base text-[#FFFFFF]">
                    Useful Links
                  </p>

                  <ul className="mt-4 space-y-3 text-sm  ">

                    {/* <li>
                      <a
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:text-gray-700/75"
                        href="a"
                      >
                        Products
                      </a>
                    </li> */}

                    <li>
                      <Link to="/about-us">
                        <a
                          className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:text-gray-700/75"
                          href="a"
                        >
                          {" "}
                          About Us{" "}
                        </a>
                      </Link>
                    </li>

                    <li>
                      <Link to="/govt-api">
                        <a
                          className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:text-gray-700/75"
                          href="a"
                        >
                          Government API
                        </a>
                      </Link>
                    </li>



                    <li>
                      <Link to="/blogs">
                        <a
                          className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:text-gray-700/75"
                          href="a"
                        >
                          {" "}
                          Blogs{" "}
                        </a>
                      </Link>
                    </li>


                    <li>
                      <a
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:text-gray-700/75"
                        href="https://hirestar.io/vendor/termspolicy.html" target='_blank'
                      >
                        {" "}
                        Privacy Policy{" "}
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="opacity-90  sm:text-left">
                  <p className="font-semibold text-base text-[#FFFFFF]">
                    Products
                  </p>

                  <ul className="mt-4 space-y-3 text-sm">

                    <li>
                      <Link to="/self-verification">
                        <a
                          className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:text-gray-700/75"
                          href="a"
                        >
                          Self Verification
                        </a>
                      </Link>
                    </li>
                    <li>
                      <Link to="/hr-portal">
                        <a
                          className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:text-gray-700/75"
                          href="a"
                        >
                          {" "}
                          HR Portal{" "}
                        </a>
                      </Link>
                    </li>
                    <li>
                      <Link to="/offer-portal">
                        <a
                          className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:text-gray-700/75"
                          href="a"
                        >
                          {" "}
                          Offer experience{" "}
                        </a>
                      </Link>
                    </li>

                    {/* <Route path="/hr-portal" element={<Hr_Portal />} />
        <Route path="/self-verification" element={<Self_Verification />} />
        <Route path="/offer-portal" element={<Offer_Portal />} />
        <Route path="/grievance-portal" element={<GR_Portal />} /> */}

                    <li>
                      <Link to="/grievance-portal">
                        <a
                          className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:text-gray-700/75"
                          href="a"
                        >
                          {" "}
                          Grievance Portal{" "}
                        </a>
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="sm:text-left mt-8 md:mt-0 lg:mt-0">
                  <p className="font-semibold text-base text-[#FFFFFF]">
                    Contact Us
                  </p>
                  <ul className="mt-4 space-y-3 text-sm">
                    <li className="flex items-center   gap-2.5 ltr:sm:justify-start rtl:sm:justify-end">
                      {/* contactIcon */}
                      <svg
                        width="32"
                        height="33"
                        viewBox="0 0 32 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.5"
                          y="0.850098"
                          width="31"
                          height="31"
                          rx="15.5"
                          fill="#0D6EB5"
                        />
                        <rect
                          x="0.5"
                          y="0.850098"
                          width="31"
                          height="31"
                          rx="15.5"
                          stroke="white"
                        />
                        <path
                          d="M20.2196 23.3503C19.6096 23.3503 18.7527 23.1297 17.4696 22.4128C15.9093 21.5378 14.7024 20.73 13.1505 19.1822C11.6543 17.6869 10.9262 16.7187 9.90709 14.8644C8.75584 12.7706 8.95209 11.6731 9.17146 11.204C9.43271 10.6434 9.81834 10.3081 10.3168 9.9753C10.5999 9.78981 10.8995 9.6308 11.2118 9.5003C11.243 9.48686 11.2721 9.47405 11.298 9.46248C11.4527 9.3928 11.6871 9.28748 11.984 9.39998C12.1821 9.47436 12.359 9.62655 12.6358 9.89998C13.2037 10.46 13.9796 11.7072 14.2658 12.3197C14.458 12.7325 14.5852 13.005 14.5855 13.3106C14.5855 13.6684 14.4055 13.9444 14.1871 14.2422C14.1462 14.2981 14.1055 14.3515 14.0662 14.4034C13.8283 14.7159 13.7762 14.8062 13.8105 14.9675C13.8802 15.2915 14.3999 16.2562 15.254 17.1084C16.108 17.9606 17.0449 18.4475 17.3702 18.5169C17.5383 18.5528 17.6305 18.4984 17.953 18.2522C17.9993 18.2169 18.0468 18.1803 18.0965 18.1437C18.4296 17.8959 18.6927 17.7206 19.0421 17.7206H19.044C19.348 17.7206 19.6083 17.8525 20.0396 18.07C20.6021 18.3537 21.8868 19.1197 22.4502 19.6881C22.7243 19.9644 22.8771 20.1406 22.9518 20.3384C23.0643 20.6362 22.9583 20.8697 22.8893 21.0259C22.8777 21.0519 22.8649 21.0803 22.8515 21.1119C22.7199 21.4236 22.56 21.7226 22.3737 22.005C22.0415 22.5019 21.7049 22.8865 21.143 23.1481C20.8545 23.2846 20.5387 23.3537 20.2196 23.3503Z"
                          fill="#F5F6FD"
                        />
                      </svg>

                      <span className="font-normal opacity-90  text-sm text-[rgb(255,255,255)]">
                        040-40198080
                      </span>
                    </li>

                    <li>
                      <a
                        className="flex items-center   gap-2.5 ltr:sm:justify-start rtl:sm:justify-end"

                      >
                        {/* mailIcon */}
                        <svg
                          width="32"
                          height="33"
                          viewBox="0 0 32 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            fill="#0D6EB5"
                          />
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            stroke="white"
                          />
                          <path
                            d="M21.168 11.1836H9.83464C9.05547 11.1836 8.42505 11.8211 8.42505 12.6003L8.41797 21.1003C8.41797 21.8794 9.05547 22.5169 9.83464 22.5169H21.168C21.9471 22.5169 22.5846 21.8794 22.5846 21.1003V12.6003C22.5846 11.8211 21.9471 11.1836 21.168 11.1836ZM20.8846 14.194L15.8767 17.3248C15.6501 17.4665 15.3526 17.4665 15.1259 17.3248L10.118 14.194C10.0469 14.1541 9.98474 14.1003 9.93514 14.0357C9.88554 13.9711 9.84955 13.8971 9.82938 13.8181C9.8092 13.7392 9.80524 13.657 9.81775 13.5766C9.83025 13.4961 9.85896 13.419 9.90213 13.3499C9.9453 13.2808 10.002 13.2212 10.0689 13.1747C10.1358 13.1282 10.2114 13.0957 10.2912 13.0793C10.3709 13.0629 10.4532 13.0628 10.533 13.0791C10.6128 13.0953 10.6885 13.1276 10.7555 13.174L15.5013 16.1419L20.2471 13.174C20.3141 13.1276 20.3898 13.0953 20.4696 13.0791C20.5494 13.0628 20.6317 13.0629 20.7115 13.0793C20.7912 13.0957 20.8668 13.1282 20.9337 13.1747C21.0006 13.2212 21.0573 13.2808 21.1005 13.3499C21.1436 13.419 21.1724 13.4961 21.1849 13.5766C21.1974 13.657 21.1934 13.7392 21.1732 13.8181C21.1531 13.8971 21.1171 13.9711 21.0675 14.0357C21.0179 14.1003 20.9557 14.1541 20.8846 14.194Z"
                            fill="#F5F6FD"
                          />
                        </svg>

                        <span className=" font-normal opacity-90  text-sm text-[rgb(255,255,255)]">
                          admin@hirestar.io
                        </span>
                      </a>
                    </li>

                    <li className="flex   items-start  gap-2.5 ltr:sm:justify-start rtl:sm:justify-end">
                      {/* location icon */}
                      <a
                        className="flex  gap-2.5 ltr:sm:justify-start rtl:sm:justify-end"

                      >
                        <svg
                          width="32"
                          height="33"
                          viewBox="0 0 32 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            fill="#0D6EB5"
                          />
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            stroke="white"
                          />
                          <path
                            d="M16.0003 8.79639C17.6626 8.79639 19.2569 9.45675 20.4323 10.6322C21.6078 11.8077 22.2681 13.4019 22.2681 15.0642C22.2681 17.7128 20.4071 20.5992 16.7331 23.7544C16.5289 23.9299 16.2684 24.0263 15.9991 24.026C15.7298 24.0258 15.4695 23.929 15.2655 23.7531L15.0225 23.5422C11.5112 20.4694 9.73242 17.6537 9.73242 15.0642C9.73242 13.4019 10.3928 11.8077 11.5682 10.6322C12.7437 9.45675 14.3379 8.79639 16.0003 8.79639ZM16.0003 12.6535C15.3609 12.6535 14.7477 12.9075 14.2956 13.3596C13.8435 13.8117 13.5896 14.4249 13.5896 15.0642C13.5896 15.7036 13.8435 16.3168 14.2956 16.7689C14.7477 17.221 15.3609 17.475 16.0003 17.475C16.6396 17.475 17.2528 17.221 17.7049 16.7689C18.157 16.3168 18.411 15.7036 18.411 15.0642C18.411 14.4249 18.157 13.8117 17.7049 13.3596C17.2528 12.9075 16.6396 12.6535 16.0003 12.6535Z"
                            fill="#F5F6FD"
                          />
                        </svg>

                        <p className="flex-1 font-normal opacity-90 text-sm text-[rgb(255,255,255)] font-poppins">
                          DappLogix Software Pvt Ltd, T-hub 2.0, Hyderabad, India
                        </p>
                      </a>
                    </li>

                    {/* 2nd  */}
                    <li className="flex   items-start  gap-2.5 ltr:sm:justify-start rtl:sm:justify-end">
                      {/* location icon */}
                      <a
                        className="flex  gap-2.5 ltr:sm:justify-start rtl:sm:justify-end"

                      >
                        <svg
                          width="32"
                          height="33"
                          viewBox="0 0 32 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            fill="#0D6EB5"
                          />
                          <rect
                            x="0.5"
                            y="0.850098"
                            width="31"
                            height="31"
                            rx="15.5"
                            stroke="white"
                          />
                          <path
                            d="M16.0003 8.79639C17.6626 8.79639 19.2569 9.45675 20.4323 10.6322C21.6078 11.8077 22.2681 13.4019 22.2681 15.0642C22.2681 17.7128 20.4071 20.5992 16.7331 23.7544C16.5289 23.9299 16.2684 24.0263 15.9991 24.026C15.7298 24.0258 15.4695 23.929 15.2655 23.7531L15.0225 23.5422C11.5112 20.4694 9.73242 17.6537 9.73242 15.0642C9.73242 13.4019 10.3928 11.8077 11.5682 10.6322C12.7437 9.45675 14.3379 8.79639 16.0003 8.79639ZM16.0003 12.6535C15.3609 12.6535 14.7477 12.9075 14.2956 13.3596C13.8435 13.8117 13.5896 14.4249 13.5896 15.0642C13.5896 15.7036 13.8435 16.3168 14.2956 16.7689C14.7477 17.221 15.3609 17.475 16.0003 17.475C16.6396 17.475 17.2528 17.221 17.7049 16.7689C18.157 16.3168 18.411 15.7036 18.411 15.0642C18.411 14.4249 18.157 13.8117 17.7049 13.3596C17.2528 12.9075 16.6396 12.6535 16.0003 12.6535Z"
                            fill="#F5F6FD"
                          />
                        </svg>

                        <p className="flex-1 font-normal opacity-90 text-sm text-[rgb(255,255,255)] font-poppins">
                          DappLogix Software Pvt Ltd, 91 springboard, Sector 2, Noida (Delhi-NCR), India
                        </p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className=" border-t border-gray-100">
            <div className=" text-center py-4">
              <p className="text-sm  text-white  sm:mt-0">
                © Copyright Hirestar.io ® Registered trademark of DappLogix
                Software Pvt Ltd - All Rights reserved 2024
              </p>
              <p className="text-sm  text-white  sm:mt-0">
                Version: {packageInfo.version}
              </p>
            </div>
          </div>
        </div>
        {/* -----------------------Copyright Section------------------------------------ */}
      </footer>
    </div>
  );
}
